export default "__VITE_ASSET__ClWNBTUp__"